import { createAsyncThunk } from "@reduxjs/toolkit";
import adminService from "../../../api/services/admin";

export const getInfoAboutAdmin = createAsyncThunk(
  "admin/get-info-about-admin",
  async () => {
    return await adminService.getInfoAboutAdmin();
  },
);

export const getUsersForAdmin = createAsyncThunk(
  "admin/get-users-for-admin",
  async ({ page, search, limit }) => {
    return await adminService.getUsersForAdmin({ page, search, limit });
  },
);

export const updateUserStatus = createAsyncThunk(
  "admin/update-user-status",
  async ({ userId, status }) => {
    return await adminService.updateUserStatus({ userId, status });
  },
);

export const deleteUser = createAsyncThunk(
  "admin/delete-user",
  async (userId) => {
    return await adminService.deleteUser(userId);
  },
);

export const updateUserRole = createAsyncThunk(
  "admin/update-user-role",
  async ({ userId, role }) => {
    return await adminService.updateUserRole({ userId, role });
  },
);
